import { observer } from 'mobx-react-lite';
import React, { FormEvent, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Form, Grid, Header, Message, Segment, Dropdown } from 'semantic-ui-react';

import { ILoginEmailPassword, SelectOption } from '../models/login';

interface IProps {
  title: string;
  description: string;
  emailPlaceholder: string;
  passwordPlaceholder: string;
  invalidCredentialsMessage: string;
  userlockedMessage: string;
  formValues: ILoginEmailPassword;
  select_options: SelectOption[];
  setFormValues: (values: ILoginEmailPassword) => void;
  handleAuthenticate: (values: ILoginEmailPassword) => Promise<void>;
}

const BmsgLoginComponent: React.FC<IProps> = ({
  title,
  description,
  emailPlaceholder,
  passwordPlaceholder,
  invalidCredentialsMessage,
  userlockedMessage,
  formValues,
  select_options,
  setFormValues,
  handleAuthenticate,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    setSubmitting(true);
    handleAuthenticate(formValues)
      .catch((error) => {
        const { data } = error.response;
        if (data.message === 'Invalid request body' || data.message === 'Invalid credentials') {
          data.errorCode
            ? toast.error(`${invalidCredentialsMessage}(${data.errorCode})`)
            : toast.error(invalidCredentialsMessage);
        } else if (data.message === 'User locked') {
          toast.error(userlockedMessage);
        }
      })
      .finally(() => setSubmitting(false));
  };

  const handleInputChange = (event: FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleDropdownChange = (_: React.SyntheticEvent, data: any) => {
    setFormValues({
      ...formValues,
      [data.name as string]: data.value,
    });
  };

  return (
    <Grid textAlign="center">
      <Grid.Column textAlign="center" style={{ width: '100%', maxWidth: 450, minWidth: 350 }}>
        <Segment>
          {title && (
            <Header as="h3" textAlign="center">
              <div dangerouslySetInnerHTML={{ __html: title }}></div>
            </Header>
          )}
          {description && (
            <Message size="tiny">
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            </Message>
          )}
          <Form.Field style={{ marginBottom: '1rem' }}>
            <div className="bmsg-auth-dropdown-wrapper">
              <Dropdown
                className="bmsg-auth-dropdown"
                fluid
                selection
                name="auth_type"
                placeholder="ファンクラブを選択"
                options={select_options}
                value={formValues.auth_type}
                onChange={handleDropdownChange}
              />
            </div>
          </Form.Field>
          <Form size="large" onSubmit={handleSubmit}>
            <Form.Input
              fluid
              icon="mail"
              iconPosition="left"
              placeholder={emailPlaceholder}
              type="email"
              name="email"
              value={formValues.email}
              onChange={handleInputChange}
            />
            <Form.Input
              fluid
              icon="user"
              iconPosition="left"
              placeholder={passwordPlaceholder}
              name="password"
              value={formValues.password}
              onChange={handleInputChange}
            />
            <Button
              fluid
              size="large"
              type="submit"
              disabled={submitting || !formValues.auth_type}
              loading={submitting}
            >
              Login
            </Button>
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

export default observer(BmsgLoginComponent);
